import React from "react"
import Helmet from "react-helmet"
import Unsubscribe from "@tightrope/footerlinks/unsubscribe"
import HomepageLayout from "src/layouts/homepage"
import JSONData from "branding/site-metadata.json"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import styles from 'src/styles/shared/legal-pages.module.scss'

export default function UnsubscribePage() {
  return(
    <HomepageLayout>
        <Helmet data={JSONData}>
          <link rel="icon" href="/img/favicon-32x32.png" sizes="32x32" />
          <title>Unsubscribe | Better Screenshot</title></Helmet>
        <div className={styles.legalPage}>
        <header style={{backgroundImage: "#e3dedb", borderBottom: "1px solidrgb(201, 201, 201)"}}>
        <img src="/img/betterscreen_logo2.png" alt="Better Screenshot Logo" />
                </header>
            <div className={styles.container}>
                <Unsubscribe hideFooter={true} />
            </div>
        </div>
        <RawFooter />
    </HomepageLayout>
  )
}
